import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-row"
}

import { onMounted } from 'vue';
import { useTenantStore } from '@/store';
import { storeToRefs } from 'pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'Quickbooks',
  setup(__props) {

const tenantStore = useTenantStore();
const { error, message, quickbooksTokenExists, loading } = storeToRefs(tenantStore);

onMounted(async () => {
  await tenantStore.getQuickbooksAPI();
});

const authenticate = () => {
  if (tenantStore.quickbooksLink) window.location.assign(tenantStore.quickbooksLink);
};

const disconnect = async () => {
  await tenantStore.revokeQuickbooks();
  await tenantStore.tokenExists();
  tenantStore.doToast(message.value, error?.value);
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("h2", null, "Quickbooks", -1)
    ]))]),
    content: _withCtx(() => [
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "...loading"))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_AppButton, {
              text: "Authenticate",
              "icon-left": "open_in_new",
              type: "secondary",
              disabled: _unref(quickbooksTokenExists),
              onClick: authenticate
            }, null, 8, ["disabled"]),
            _createVNode(_component_AppButton, {
              text: "Disconnect",
              class: "ml-3",
              "icon-left": "link-off",
              type: "alert",
              disabled: !_unref(quickbooksTokenExists),
              onClick: disconnect
            }, null, 8, ["disabled"])
          ]))
    ]),
    _: 1
  }))
}
}

})